import { FirebaseAppFirestore } from '@/firebase/firebase-app';
import { getCurrentUser } from '@/firebase/firebase-user';
import firebaseNames from '@/statics/firebase-names';
import { Campaign, CampaignRequest, UpdatedCampaignPropertiesWhenMediaChanged } from '@/types/campaigns';
import { CampaignMedia } from '@/types/media';
import { updateDocumentRef } from '@/utils/db-hooks';

/**
 * Load all campaigns of current user
 */
export const loadMyCampaigns = async (): Promise<Campaign[]> => {
  const currentUser = await getCurrentUser();
  const campaignsSnap = await FirebaseAppFirestore.collection(
    firebaseNames.CAMPAIGNS.VAL
  )
    .doc(currentUser!.uid)
    .collection(firebaseNames.CAMPAIGNS.USER_CAMPAIGNS)
    .get();

  if (campaignsSnap.empty) {
    return [];
  }
  const data = await Promise.all(
    campaignsSnap.docs.map((campaignDoc) => campaignDoc.data() as Campaign)
  );

  return data;
};

/**
 * Change campaign media list
 * @param campaignRequest - Campaign request
 * @param mediaList - Media list
 * @param resetFields -
 * Reset this fields:
 *  admin approval,
 *  store owner approval,
 *  status,
 *  media change request status,
 *  comments,
 *  media change requested at,
 *  approved by admin at
 */
export const changeCampaignMediaList = async (
  campaignRequest: CampaignRequest,
  mediaList: CampaignMedia[],
  resetFields?: UpdatedCampaignPropertiesWhenMediaChanged,
): Promise<void> => {
  const { ID, ADVERTISER_UID } = campaignRequest;

  const campaignRef = FirebaseAppFirestore.collection(
    firebaseNames.CAMPAIGNS.VAL
  )
    .doc(ADVERTISER_UID)
    .collection(firebaseNames.CAMPAIGNS.USER_CAMPAIGNS)
    .doc(ID);

  await updateDocumentRef(campaignRef,{
    MEDIA_LIST: mediaList,
    ...resetFields,
  });
  return;
};
